angular.module('aprima-legacy-common').factory('WebViewManager',
    ['$log', 'BrowserWebViewManager', 'XamarinWebViewManager', 'DeviceSettings',
        function ($log, BrowserWebViewManager, XamarinWebViewManager, DeviceSettings) {
            'use strict';

            var webViewManager;

            if (DeviceSettings.isStandaloneBrowser) {
                $log.info('Using BrowserWebViewManager for standalone browser');
                webViewManager = BrowserWebViewManager;
            } else if (DeviceSettings.isDevice || DeviceSettings.isPrm) {
                $log.info('Using XamarinWebViewManager');
                webViewManager = XamarinWebViewManager;
            } else {
                $log.info('Using BrowserWebViewManager');
                webViewManager = BrowserWebViewManager;
            }

            return webViewManager;
        }]);
